import { Box } from '@mui/material';
import { useMemo } from 'react';
import Grid2 from '@thirdparty-framework/mui/material/Grid';
import {
  BACK_BUTTON_LAYOUT,
  SmartStepperTabs,
  useMasterData,
  useStore,
  useUserAccess,
  FormErrors,
  BreadcrumbRouterBased,
} from '@ui-framework/index';
import { observer } from 'mobx-react';
import {
  IconLibrary,
  Layout,
  StackablePageButtons,
} from '@product-framework/index';
import getStepperConfig from '../configs/stepperConfig';
import { useServiceProvider } from '../../../providers/ServiceProviderProvider';
import ProfileCompleteness from './ProfileCompleteness';

function ServiceProviderLayout({
  stackablePageButtons,
  children,
  showWarnings = true,
  selectedStepperId = null,
  stepperDisableExceptFirst = false,
}) {
  const userAccess = useUserAccess();
  const masterData = useMasterData();
  const store = useStore();
  const {
    dispatchMethod,
    profileWarnings,
    serviceProviderId,
    locationId,
    errors,
    serviceProvider,
    location,
    user,
  } = useServiceProvider();

  const serviceAreaEnabled =
    masterData?.applicationFeatureDemo?.serviceArea || false;

  const dispatchCalendarEnabled =
    masterData?.applicationFeatureDemo?.dispatchCalendar || false;

  const hasAvailabilityFeature =
    dispatchCalendarEnabled &&
    masterData.dispatchMethods.find(
      i => i.value === 'PRESET_CALENDAR_BASED_SCHEDULING' && i.status === true,
    ) &&
    dispatchMethod?.dispatchMethod === 'PRESET_CALENDAR_BASED_SCHEDULING';

  const config = useMemo(() => {
    return getStepperConfig({
      userAccess,
      hasAvailabilityFeature,
      serviceProviderId,
      locationId,
      serviceAreaEnabled,
      status: profileWarnings,
    });
  }, [profileWarnings]);

  return (
    <Layout>
      <Grid2 xs={12} container>
        {Array.isArray(errors) && errors?.length > 0 && (
          <Grid2 xs={12} md={12}>
            <FormErrors errors={errors} />
          </Grid2>
        )}
        <Grid2 xs={12} md={7}>
          <BreadcrumbRouterBased
            data={{
              companyName: serviceProvider?.name,
              spUserFLName: `${user?.firstName} ${user?.lastName}`,
              locationName: location?.locationName,
            }}
            IconLibrary={IconLibrary}
          />
        </Grid2>
        <Grid2 xs={12} md={5}>
          <StackablePageButtons buttons={stackablePageButtons} />
        </Grid2>
      </Grid2>
      {showWarnings && (
        <Grid2 xs={12}>
          <Box>
            <ProfileCompleteness
              store={store}
              serviceProviderId={serviceProviderId}
              profileWarnings={profileWarnings}
            />
          </Box>
        </Grid2>
      )}
      <Grid2 xs={12}>
        <Box>
          <SmartStepperTabs
            stepperDisableExceptFirst={stepperDisableExceptFirst}
            selectedId={selectedStepperId}
            backButtonLayout={BACK_BUTTON_LAYOUT.PARENT}
            config={config}
            // pass profileWarnings if SmartStepperTabs supports status/errors
          />
        </Box>
      </Grid2>
      <Grid2 xs={12}>{children}</Grid2>
    </Layout>
  );
}

export default observer(ServiceProviderLayout);
